module.exports = __webpack_public_path__ + "static/brand-5-9edfd423f68eae2b91fc836d8e315084.png";